"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

require("./Heading.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @visibleName Headings
 */
function Heading(_ref) {
  var level = _ref.level,
      children = _ref.children,
      color = _ref.color,
      margin = _ref.margin,
      className = _ref.className;
  var classes = ['heading'];
  var styles = {
    color: color,
    margin: margin
  };
  var H;
  classes.push(Heading.levels[level]);
  H = 'h'.concat(level.substring(0, 1));

  if (className) {
    classes.push(className);
  }

  return /*#__PURE__*/_react.default.createElement(H, {
    className: classes.join(' '),
    style: styles
  }, children);
}

Heading.propTypes = {
  /** Elements to be rendered as children of this component */
  children: _propTypes.default.node,

  /** The heading level to render */
  level: _propTypes.default.oneOf(['1+', '1+L', '1', '1L', '2', '3', '3L', '4']),

  /** Color */
  color: _propTypes.default.string,

  /** Margin */
  margin: _propTypes.default.string
};
Heading.defaultProps = {
  level: '1',
  color: _Colors.default.vagaVesi,
  margin: '0'
};
Heading.levels = {
  '1+': 'css-1-plus',
  '1+L': 'css-1-plus-L',
  1: 'css-1',
  '1L': 'css-1-L',
  2: 'css-2',
  3: 'css-3',
  '3L': 'css-3-L',
  4: 'css-4'
};
var _default = Heading;
exports.default = _default;